import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface RegistryProject {
  project_id: string;
  name: string;
  type: string;
  project_period: [string, string];
  organization: string;
  status: string;
  region: string;
  [key: string]: any;
}

export interface RegistryResponse {
  data: RegistryProject[];
}

const REGISTRY_API_URL = process.env.REACT_APP_REGISTRY_API_URL || "";

export const registryApi = createApi({
  reducerPath: "registryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: REGISTRY_API_URL,
  }),
  tagTypes: ["Registry"],
  endpoints: (build) => ({
    getRegistry: build.query<RegistryResponse, void>({
      query: () => "/rs/registry/project",
      providesTags: ["Registry"],
    }),

  }),
});

export const { useGetRegistryQuery } = registryApi;
